import * as React from 'react';
import classnames from 'classnames';

import Link from 'libs/router/Link';

import './entity-name.scss';

import type { Entity } from 'types';

type Style = {
  [x: string]: unknown
};

export type EntityNameProps = {
  multiline?: boolean,
  maxLength: number,
  link?: string,
  size: 'xsmall' | 'small' | 'normal' | 'large' | 'inherit',
  style: Style,
  hideTitle?: boolean,
  className?: string,
  onClick?: (a: React.SyntheticEvent<HTMLElement>) => void,
  openInNewTab: boolean
};

export const EntityNameDefaultProps: EntityNameProps = {
  style: {},
  maxLength: 50,
  size: 'normal',
  openInNewTab: false,
  hideTitle: false
};

type Props = EntityNameProps & {
  entity: Entity | null
};

class EntityName extends React.PureComponent<Props> {
  static defaultProps = EntityNameDefaultProps;

  render() {
    const {
      entity,
      link,
      multiline,
      size,
      maxLength,
      openInNewTab,
      hideTitle,
      className,
      style,
      onClick
    } = this.props;

    if (!entity) {
      return null;
    }

    const classes = classnames({
      'entity-name': true,
      'entity-name--link': link,
      [`entity-name--size-${size}`]: size,
      'text-overflow-ellipsis': !multiline,
      [String(className)]: Boolean(className)
    });

    const entityDisplayName = entity.displayName;
    let displayName = entityDisplayName || '';

    if (multiline && displayName.length > maxLength) {
      displayName = `${displayName.slice(0, maxLength).trim()}...`;
    }

    if (!link) {
      return (
        <span className={classes} title={entityDisplayName} style={style}>
          {displayName}
        </span>
      );
    }

    if (openInNewTab) {
      return (
        <a
          href={link}
          target="_blank"
          rel="noopener noreferrer"
          title={!hideTitle ? entityDisplayName : ''}
          className={classes}
          style={style}
          onClick={onClick}
        >
          {displayName}
        </a>
      );
    }

    return (
      <Link
        to={link}
        title={!hideTitle ? entityDisplayName : ''}
        className={classes}
        style={style}
      >
        {displayName}
      </Link>
    );
  }
}

export default EntityName;
